import configs from 'configs';
import { authHeaders } from 'functions/authHeader';
import request from 'functions/api/request';
import { isArray } from 'lodash';

const apiUrl = configs.beApiUrl;

const prepareUser = (user) => {
  const _user = window.structuredClone(user);
  if (_user?.condition_profile?.treatments?.length && isArray(_user?.condition_profile?.treatments)) {
    _user.condition_profile.treatments = _user.condition_profile.treatments.filter((t) => {
      if (t.drugs_received) return true;
      return false;
    });
  }
  return _user;
};

export const hcpApi = {
  addPatient: async (patientUserWixId) => {
    let response = null;

    const requestOptions = {
      url: `${apiUrl}/user/care-assistant/patient`,
      headers: await authHeaders(),
      data: { patientUserWixId },
      json: true,
    };

    try {
      response = await request.post(requestOptions);
    } catch (ex) {
      console.error('Error occurred, while adding patient to existing user:', ex);
      throw ex;
    }

    return response;
  },

  updatePatient: async (patient) => {
    const patientUserWixId = patient.info.user_wix_id;
    let response = null;

    if (patient?.info?.country?.name) {
      // !!! mutation
      // eslint-disable-next-line no-param-reassign
      patient.info.country.label = patient.info.country.name;
    }

    const data = prepareUser(patient);

    const requestOptions = {
      url: `${apiUrl}/user/care-assistant/patient/${patientUserWixId}`,
      headers: await authHeaders(),
      data,
      json: true,
    };

    try {
      response = await request.put(requestOptions);
    } catch (ex) {
      console.error('Error occurred, while updating existing patient:', ex);
      throw ex;
    }

    return response;
  },

  getPublicMatches: async (user, { signal } = {}) => {
    let response = null;

    let data = user;
    if (data?.personal?.condition) {
      data = {
        ...data,
        personal: {
          ...data.personal,
          last_updated_question: null,
        },
      };
    }

    data = prepareUser(data);

    const requestOptions = {
      url: `${apiUrl}/public/trials/match`,
      data,
      json: true,
      signal,
    };

    try {
      response = await request.post(requestOptions);
    } catch (ex) {
      console.error('Error occurred: getMatchesByUser', ex);
      throw ex;
    }

    return response;
  },

  sharePatientMatchesWithDoctor: async (data) => {
    const requestOptions = {
      url: `${apiUrl}/profile/care-assistant/patientMatches/shareViaEmail`,
      headers: await authHeaders(),
      data,
      json: true,
    };

    try {
      return await request.post(requestOptions);
    } catch (ex) {
      console.error('Error occurred: shareWithDoctor', ex);
      throw ex;
    }
  },
  getMatchesPDF: async (data) => {
    const requestOptions = {
      url: `${apiUrl}/profile/care-assistant/patientMatches/pdf`,
      headers: await authHeaders(),
      data,
      json: true,
      isBlob: true,
    };

    try {
      return await request.post(requestOptions);
    } catch (ex) {
      console.error('Error occurred: getMatchesPDF', ex);
      throw ex;
    }
  },
};
